import { AlertColor, Box, CircularProgress, Grid } from "@mui/material";
import Iconborder from "../IconBorder";
import { AccountCircle, Apartment, Key, Verified } from "@mui/icons-material";
import { KeyDriveh4Header } from "../../../../../components/KeydriveComponents/Fonts/Headers/KeyDriveh4Header";
import { KeyDriveBodyMin } from "../../../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMin";
import ForwardBackButton from "../ForwardBackButton";
import { useTranslation } from "react-i18next";
import { IRegisterUserObject, IStepItem } from "../../Register";
import ConcludedStepsVisual from "../ConcludedStepsVisual";
import { CreateUserAccount } from "../../../../../services/AccountService";
import { ICreateUserVO } from "../../../../../model/AccountModels";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

interface IConcludedWizard {
    backStep: () => void;
    forwardStep: () => void;
    createUserObject: IRegisterUserObject;
    setAlertColor: (set: AlertColor) => void;
    setMessage: (set: string) => void;
    stepList: IStepItem[];
    step: number;
    setStep: (set: number) => void;
}

export default function ConcludedWizard({
    backStep,
    forwardStep,
    createUserObject,
    setAlertColor,
    setMessage,
    stepList,
    setStep,
    step
}: IConcludedWizard): JSX.Element {

    const { t } = useTranslation();
    const [accountCreationLoader, setAccountCreationLoader] = useState<boolean>(false);
    const navigate = useNavigate();

    async function CreateUserAccountAsync(input: ICreateUserVO): Promise<void> {
        setAccountCreationLoader(true);
        CreateUserAccount(input)
        .then(data => {
            console.log(data)
            navigate(`/plan/${input.email}/${data.internalName}`);
        })
        .catch(err => {
            if (err.response == undefined && err?.response?.data == undefined) {
                setMessage("Ocorreu um erro ao tentar registrar sua conta");
                setAlertColor("error");
            } else {
                setMessage(err.response.data);
                setAlertColor("error");
            }
        })
        .finally(() => {
            setAccountCreationLoader(false);
        })
    }

    return (
        <>
            <Grid item xs={12} display="flex" justifyContent="center" marginBottom="12px">
                <Iconborder>
                    <Verified sx={{ color: "#22638D", width: "36px", height: "36px" }} />
                </Iconborder>
            </Grid>
            <Grid item xs={12} textAlign="center" marginBottom="20px">
                <KeyDriveh4Header
                    color={"#22638D"}
                    needBold
                    needEllipses={false}
                    text={t("RegisterPage.steps.step5.title")}
                    sxStyles={{
                        marginBottom: "12px"
                    }}
                />
                <KeyDriveBodyMin
                    color="#7AA1BB"
                    needBold={false}
                    needEllipses={false}
                    text={t("RegisterPage.steps.step5.content")}
                />
            </Grid>
            <Grid item xs={12} display="flex" justifyContent="space-between" marginTop="12px">
                <Box
                    width="480px"
                    height="273px"
                    border="1px solid #DEE8EE"
                >
                    <ConcludedStepsVisual 
                        contentText="Nome completo"
                        icon={<AccountCircle sx={{ color: "#22638D", width: "26px", height: "26px", marginRight: "4px" }} />}
                        contentVisual={createUserObject.username}
                        titleText={t("RegisterPage.steps.step1.title")}
                        step={1}
                        setStep={setStep}
                    />
                    <ConcludedStepsVisual 
                        contentText=""
                        icon={<Key sx={{ color: "#22638D", width: "26px", height: "26px", marginRight: "4px" }} />}
                        contentVisual={""}
                        titleText={t("RegisterPage.steps.step2.title")}
                        step={2}
                        setStep={setStep}
                    />
                    <ConcludedStepsVisual 
                        contentText="Nome da organização"
                        icon={<Apartment sx={{ color: "#22638D", width: "26px", height: "26px", marginRight: "4px" }} />}
                        contentVisual={createUserObject.organizationName}
                        titleText={t("RegisterPage.steps.step3.title")}
                        step={3}
                        setStep={setStep}
                    />
                </Box>
            </Grid>
            { accountCreationLoader ? (
                <Grid item xs={12} display="flex" justifyContent="center" alignItems="center" marginTop="20px" spacing={2}>
                    <CircularProgress variant="indeterminate" />
                </Grid>
            ) : (
                <ForwardBackButton
                    backStep={backStep}
                    forwardStep={() => {
                        CreateUserAccountAsync({
                            confirmPassword: createUserObject.confirmPassword,
                            password: createUserObject.password,
                            username: createUserObject.username,
                            email: createUserObject.email,
                            organizationName: createUserObject.organizationName
                        });
                    }}
                />
            ) }
        </>
    )
}